// extracted by mini-css-extract-plugin
export default {"container":"CustomBreadcrumbs_container__-ksyp","list":"CustomBreadcrumbs_list__ufDrn","text":"CustomBreadcrumbs_text__hn14m"};